import { useQuery } from '@tanstack/react-query';

import ApiSite from '@Api/Site';

import type { UseQueryResult } from '@tanstack/react-query';

export interface Params {
  productId: number;
}

export interface Result {
  text: string;
}

const usePreorderDate = (params: Params): UseQueryResult<Result> => {
  const { productId } = params;
  const keys = ['preorder', productId];

  return useQuery({
    queryKey: keys,
    queryFn: () => {
      return ApiSite.getPreorderDate({ productId });
    },
    placeholderData: (previousData) => previousData,
  });
};

export default usePreorderDate;
